// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Annotation .CommentLine {\n  position: absolute;\n  pointer-events: none;\n  z-index: 2; /* So that downward lines will hover over subsequent pages */\n}\n", ""]);
// Exports
module.exports = exports;
